import Image, { ImageProps } from 'next/image'

interface NextImageProps extends Omit<ImageProps, 'src' | 'alt'> {
  src?: string | null
  alt?: string | null
  // Used when `src` is null/empty. Lets a callsite show a static asset
  // (e.g. /placeholders/avatar.svg) instead of rendering nothing.
  fallbackSrc?: string | null
}

export const NextImage = (props: NextImageProps) => {
  const { src, alt, fallbackSrc, ...rest } = props
  const resolvedSrc = src || fallbackSrc

  if (!resolvedSrc) return null

  return (
    <Image alt={alt || ''} src={resolvedSrc} {...rest} />
  )
}